import { InputLabel } from "@mui/material";
import { useIsMobile } from "hooks/useIsMobile";
import type { ReactNode } from "react";
import { forwardRef, memo } from "react";
import { useTranslation } from "react-i18next";

interface InputLabelProps {
    children: ReactNode;
    htmlFor: string;
    optional?: boolean;
    className?: string;
    required?: boolean;
    style?: React.CSSProperties;
}

const LabelComponent = forwardRef<any, InputLabelProps>(function LabelComponent(props: InputLabelProps, ref) {
    const { children, optional, htmlFor, className, required, style } = props;
    const { isMobile } = useIsMobile();

    const [t] = useTranslation();

    return (
        <InputLabel
            {...props}
            htmlFor={htmlFor}
            style={isMobile ? { ...style, ...componentStyle.mobile } : { ...style, ...componentStyle.desktop }}
            ref={ref}
            className={className}
        >
            {children}
            {optional && <span style={{ color: "#909090" }}> {t("NewTitle.Optional")}</span>}
            {required && <span style={{ color: "#909090" }}>*</span>}
        </InputLabel>
    );
});

const componentStyle = {
    mobile: {
        color: "var(--foreground)",
        fontSize: "13px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
    desktop: {
        color: "var(--foreground)",
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: "Poppins",
    },
};

export default memo(LabelComponent);
